import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetAccountQuery, useGetUserQuery, Module, AccountMembershipRole } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var showExpiryWarningDialog = ref(false);
    var pendingRedirectPath = ref('');
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var account = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var isIxAdmin = computed(function () {
      var _user$value;
      return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin);
    });
    var isFullyExpiredForCustomer = computed(function () {
      var _account$value, _account$value2;
      return ((_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.type) === 'PORTFOLIO' && ((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.expiryStatus) === 'EXPIRED' && !isIxAdmin.value;
    });
    var expiryWarningText = computed(function () {
      var _account$value3;
      var status = (_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.expiryStatus;
      if (status === 'EXPIRED') {
        return 'This account is suspended. Contact help@impactnexus.io for renewal.';
      }
      if (status === 'IN_GRACE') {
        return 'Your portfolio account has passed the expiry date and is currently in grace period. Please contact help@impactnexus.io for renewal.';
      }
      return 'Your portfolio account is nearing expiry. Please contact help@impactnexus.io for renewal.';
    });
    var formattedExpiryDate = computed(function () {
      var _account$value4;
      var raw = (_account$value4 = account.value) === null || _account$value4 === void 0 ? void 0 : _account$value4.expiryDate;
      if (!raw) return '';
      return /^\d{4}-\d{2}-\d{2}/.test(raw) ? raw.slice(0, 10) : raw;
    });
    var daysUntilExpiry = computed(function () {
      var _account$value5;
      var raw = (_account$value5 = account.value) === null || _account$value5 === void 0 ? void 0 : _account$value5.expiryDate;
      if (!raw || !/^\d{4}-\d{2}-\d{2}/.test(raw)) return null;
      var _raw$slice$split$map = raw.slice(0, 10).split('-').map(Number),
        _raw$slice$split$map2 = _slicedToArray(_raw$slice$split$map, 3),
        year = _raw$slice$split$map2[0],
        month = _raw$slice$split$map2[1],
        day = _raw$slice$split$map2[2];
      var expiry = Date.UTC(year, month - 1, day);
      var today = new Date();
      var todayUtc = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
      return Math.round((expiry - todayUtc) / (24 * 60 * 60 * 1000));
    });
    var daysToExpiryLabel = computed(function () {
      var days = daysUntilExpiry.value;
      if (days == null) return '';
      if (days > 1) return "Days until expiry: ".concat(days);
      if (days === 1) return 'Days until expiry: 1';
      if (days === 0) return 'Expires today';
      if (days === -1) return 'Days past expiry: 1';
      return "Days past expiry: ".concat(Math.abs(days));
    });
    watch(account, function (account) {
      if (!account || loading.value) {
        return;
      }
      if (isFullyExpiredForCustomer.value) {
        return;
      }
      var path = '';
      if ((account === null || account === void 0 ? void 0 : account.type) === 'VENTURE') {
        path = "/".concat(account.id, "/modules");
      } else if ((account === null || account === void 0 ? void 0 : account.type) === 'PORTFOLIO') {
        var _account$modules, _account$bookedModule, _account$modules2, _account$bookedModule2;
        var roles = (account === null || account === void 0 ? void 0 : account.membershipRoles) || [];
        var showReviewerShell = roles.includes(AccountMembershipRole.Reviewer) && !roles.includes(AccountMembershipRole.Editor);
        if (account !== null && account !== void 0 && (_account$modules = account.modules) !== null && _account$modules !== void 0 && _account$modules.includes(Module.Review) && showReviewerShell) {
          path = '/portfolio/review';
        } else if (account !== null && account !== void 0 && (_account$bookedModule = account.bookedModules) !== null && _account$bookedModule !== void 0 && _account$bookedModule.includes(Module.Esg) || account !== null && account !== void 0 && (_account$modules2 = account.modules) !== null && _account$modules2 !== void 0 && _account$modules2.includes(Module.Esg)) {
          path = '/portfolio/dashboard';
        } else if (account !== null && account !== void 0 && (_account$bookedModule2 = account.bookedModules) !== null && _account$bookedModule2 !== void 0 && _account$bookedModule2.includes(Module.ImpactGoal)) {
          path = '/portfolio/impactGoalList';
        } else {
          path = '/portfolio/metrics';
        }
      }
      if ((account === null || account === void 0 ? void 0 : account.type) === 'PORTFOLIO' && ['EXPIRING_SOON', 'IN_GRACE', 'EXPIRED'].includes(account === null || account === void 0 ? void 0 : account.expiryStatus)) {
        pendingRedirectPath.value = path;
        showExpiryWarningDialog.value = true;
        return;
      }
      if (path && route.path !== path) {
        router.push(path);
      }
    }, {
      immediate: true
    });
    watch(showExpiryWarningDialog, function (isOpen) {
      if (!isOpen && pendingRedirectPath.value && route.path !== pendingRedirectPath.value) {
        router.push(pendingRedirectPath.value);
        pendingRedirectPath.value = '';
      }
    });
    return {
      __sfc: true,
      router: router,
      route: route,
      $auth: $auth,
      showExpiryWarningDialog: showExpiryWarningDialog,
      pendingRedirectPath: pendingRedirectPath,
      result: result,
      loading: loading,
      userResult: userResult,
      account: account,
      user: user,
      isIxAdmin: isIxAdmin,
      isFullyExpiredForCustomer: isFullyExpiredForCustomer,
      expiryWarningText: expiryWarningText,
      formattedExpiryDate: formattedExpiryDate,
      daysUntilExpiry: daysUntilExpiry,
      daysToExpiryLabel: daysToExpiryLabel
    };
  }
});